declare global {
  interface Window {
    google_tag_manager: {
      [key: string]: {
        dataLayer: {
          length: any;
          push: any;
          get: (key: string) => any;
        };
      };
    };
  }
}

export const GTM_ID = 'GTM-53PCC52';

export const getDataLayer = () => {
  if (typeof window === 'undefined') return null;
  return window.google_tag_manager?.[GTM_ID]?.dataLayer;
};

export const getGtmData = (gtmDataLayer: { length?: any; push?: any; get: any }) => {
  const mktgData = {
    consent_state: gtmDataLayer?.get('consent_state'),
    mktg_click_id: gtmDataLayer?.get('mktg_click_id'),
    mktg_platform: gtmDataLayer?.get('mktg_platform'),
    mktg_source: gtmDataLayer?.get('mktg_source'),
    mktg_medium: gtmDataLayer?.get('mktg_medium'),
    mktg_campaign: gtmDataLayer?.get('mktg_campaign'),
    mktg_term: gtmDataLayer?.get('mktg_term'),
    mktg_content: gtmDataLayer?.get('mktg_content'),
    ga_client_id: gtmDataLayer?.get('ga_client_id'),
  };
  return mktgData;
};
